import { atom } from 'jotai';

export interface CutoffDate {
  cutoffDate: string;
  cutoffText: string;
}

export const cutoffAtom = atom<CutoffDate | null>(null);
